import gql from 'graphql-tag';
export const jobInformation = gql`
  fragment jobInformation on JobInformation {
    postedBy
    positionCreatedDate
    listingStartedDate
    expiredDate
    positionId
    listingId
    questionnaireId
    jobId
    numberOfDaysRemaining
  }
`;
